import { useContext, createContext } from 'react';
import { RuleObject } from 'antd/lib/form';

import { ApplicationPayload } from '~/types/ApplicationPayload';
import { Draft } from '~/types/Draft';
import { KsaError } from '~/types/ksa/KsaError';

interface ContextType {
  defaultValidator?: RuleObject['validator'];
  disabled?: boolean;
  disabledByDefault?: boolean;
  optionalFields?: Record<string, string>;
  applicationPayload?: ApplicationPayload;
  draftPayload?: Draft<any>;
  errorFields?: KsaError[];
  enabledFields?: string[];
}

const Context = createContext<ContextType>({});
export const FormItemContextProvider = Context.Provider;
export const useFormItemContext = () => useContext(Context);
